// src/i18n.js
import { createI18n } from "vue-i18n";
import ar from "./locales/ar.json";
import az from "./locales/az.json";
import bg from "./locales/bg.json";
import bn from "./locales/bn.json";
import cs from "./locales/cs.json";
import da from "./locales/da.json";
import de from "./locales/de.json";
import el from "./locales/el.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import et from "./locales/et.json";
import fa from "./locales/fa.json";
import fi from "./locales/fi.json";
import fr from "./locales/fr.json";
import hi from "./locales/hi.json";
import hu from "./locales/hu.json";
import hy from "./locales/hy.json";
import id from "./locales/id.json";
import it from "./locales/it.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import lo from "./locales/lo.json";
import lt from "./locales/lt.json";
import mn from "./locales/mn.json";
import my from "./locales/my.json";
import nl from "./locales/nl.json";
import no from "./locales/no.json";
import pl from "./locales/pl.json";
import pt from "./locales/pt.json";
import ro from "./locales/ro.json";
import ru from "./locales/ru.json";
import sh from "./locales/sh.json";
import si from "./locales/si.json";
import sk from "./locales/sk.json";
import sq from "./locales/sq.json";
import sv from "./locales/sv.json";
import th from "./locales/th.json";
import tr from "./locales/tr.json";
import uk from "./locales/uk.json";
import uz from "./locales/uz.json";
import vi from "./locales/vi.json";
import zh from "./locales/zh.json";

const messages = {
  ar,
  az,
  bg,
  bn,
  cs,
  da,
  de,
  el,
  en,
  es,
  et,
  fa,
  fi,
  fr,
  hi,
  hu,
  hy,
  id,
  it,
  ja,
  ko,
  lo,
  lt,
  mn,
  my,
  nl,
  no,
  pl,
  pt,
  ro,
  ru,
  sh,
  si,
  sk,
  sq,
  sv,
  th,
  tr,
  uk,
  uz,
  vi,
  zh,
};

const i18n = createI18n({
  locale: "en", // Set default locale
  fallbackLocale: "en", // Set fallback locale
  messages,
});

export default i18n;
